const BASE_URL = "https://dev-api.braytron.space/api";
const DEFAULT_DEBOUNCE_TIME = 500;

export { BASE_URL, DEFAULT_DEBOUNCE_TIME };
